module.exports = __webpack_public_path__ + "img/amex.12a16e0f.png";